export default "<p class='alertText'>\n\n    <js-templateNonce></js-templateNonce>\n    {{- message }}\n</p>";